import React, { useRef, useState } from 'react';
import Cross from '../../../../../Assets/Modals/closeIcon.svg';
import PasswordInput from './PasswordInput';
import { updatePassword } from '../../../../../lib/utils/apiCalls';
import { useDispatch } from 'react-redux';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import { closeSettingsModal } from '../../../../../Features/settingsSlice';
import { useOutsideClickHandler } from '../../../../../Hooks/useOutsideClick';

function ChangePassword() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        closeForm();
    });

    const defaultFormInputs = {
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
    };

    const [formInputs, setFormInputs] = useState(defaultFormInputs);
    const [formErrors, setFormErrors] = useState(defaultFormInputs);

    function changeHandler(e) {
        const { name, value } = e.target;

        setFormInputs({ ...formInputs, [name]: value });
    }

    function closeForm() {
        dispatch(closeSettingsModal());
    }

    async function changePassword() {
        const validationErrors = {};

        if(!formInputs.currentPassword) {
            validationErrors.currentPassword = 'Required field';
        }

        if(!formInputs.newPassword) {
            validationErrors.newPassword = 'Required field';
        }
        else if(formInputs.newPassword.length < 6) {
            validationErrors.newPassword = 'Password length must be at least 6 characters long';
        }

        if(!formInputs.confirmNewPassword) {
            validationErrors.confirmNewPassword = 'Required field';
        }
        else if(formInputs.newPassword !== formInputs.confirmNewPassword) {
            validationErrors.confirmNewPassword = 'Passwords don\'t match';
        }

        if(Object.keys(validationErrors).length === 0) {
            setFormErrors(defaultFormInputs);

            const callBody = {
                prevPassword: formInputs.currentPassword,
                newPassword: formInputs.confirmNewPassword,
            }

            try {
                const response = await updatePassword(callBody);

                if(response.status === 200) {
                    showToast('Successfully updated password.', 'success');
                    closeForm();
                    return;
                }
            }
            catch(err) {
                showToast(err, 'error');
            }
        }
        else {
            setFormErrors(validationErrors);
            return;
        }
    }

    return (
        <div ref={wrapperRef} className='w-[600px] bg-[#FFFFFF] shadow-[0_0_6px_0_#0000001F] p-6 rounded-xl flex flex-col gap-6'>
            <div className="flex items-center justify-between">
                <div className="flex flex-col">
                    <h1 className='font-semibold text-[24px] leading-7 text-[#121212]'>Change Password</h1>

                    <p className='font-normal text-[16px] leading-5 text-[#808080]'>Enter your current password to Make Update</p>
                </div>

                <button onClick={closeForm} className='outline-none size-11 p-[10px] flex items-center justify-center'>
                    <img className='size-6 p-[6px]' src={Cross} alt="" />
                </button>
            </div>

            <PasswordInput 
                title={'Enter Current Password'} 
                errorText={formErrors.currentPassword} 
                inputOptions={{
                    id: 'currentPassword',
                    name: 'currentPassword',
                    value: formInputs.currentPassword,
                    onChange: changeHandler,
                }}
            />

            <PasswordInput 
                title={'Enter New Password'} 
                errorText={formErrors.newPassword} 
                inputOptions={{
                    id: 'newPassword',
                    name: 'newPassword',
                    value: formInputs.newPassword,
                    onChange: changeHandler,
                }}
            />

            <PasswordInput 
                title={'Confirm New Password'} 
                errorText={formErrors.confirmNewPassword} 
                inputOptions={{
                    id: 'confirmNewPassword',
                    name: 'confirmNewPassword',
                    value: formInputs.confirmNewPassword,
                    onChange: changeHandler,
                }}
            />

            <button onClick={changePassword} className='w-full bg-primaryColor hover:bg-primaryAccent px-4 py-2 rounded font-semibold text-base text-buttonText'>Change Password</button>
        </div>
    );
}

export default ChangePassword;
